"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyAndFormatDate = exports.readingContext = exports.meterReadings = exports.useConsumptionRows = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var groupBy_1 = require("../../../../../../../shared/core/utils/groupBy");
var number_1 = require("../../../../../../../shared/core/utils/number");
var utils_1 = require("../../../../../../meter-reads/utils");
var copy_1 = require("../../../../../copy");
var date_1 = require("../../../../../utils/date");
var ElecTypes = [
    'Anytime',
    'Peak',
    'Offpeak',
    'Evening_and_weekend',
    'Heating',
];
var readingSortOrder = {
    Anytime: 0,
    Peak: 1,
    Offpeak: 2,
    Evening_and_weekend: 3,
    Heating: 4,
};
var sortReadings = function (a, b) {
    if (!(a.label in ElecTypes) || !(b.label in ElecTypes)) {
        return 1;
    }
    return readingSortOrder[a.label] - readingSortOrder[b.label];
};
// Map consumption blocks from api into format for display
// groups by regster tier if present (eg day/night/anytime)
// modified from ../charges-in-detail/fuel/FuelSection
function useConsumptionRows(supplyPointRegisterCharges, fuel) {
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return supplyPointRegisterCharges.map(function (supplyPointRegisterCharge) {
        if (!supplyPointRegisterCharge.consumptionRates) {
            return __assign(__assign({}, supplyPointRegisterCharge), { sortedRows: [] });
        }
        var multiRateGroups = Object.entries((0, groupBy_1.groupBy)(supplyPointRegisterCharge.consumptionRates, function (a) { return a.friendlyLabel; }));
        var rows = multiRateGroups.map(function (_a) {
            var _b = __read(_a, 2), label = _b[0], consumptionBlocks = _b[1];
            var totalKwh = (0, number_1.sum)(consumptionBlocks.map(function (_a) {
                var kwh = _a.kwh;
                return Number(kwh);
            }));
            var readings = meterReadings(consumptionBlocks);
            return {
                title: supplyPointRegisterCharge.isMultiRate ? (react_1.default.createElement(Copy, { copyKey: "multiRateReadsTitle", props: { friendlyLabel: label } })) : (''),
                label: label,
                totalKwh: totalKwh.toString(),
                readings: readings,
            };
        });
        var sortedRows = fuel === 'electricity' ? rows.sort(sortReadings) : rows;
        return __assign(__assign({}, supplyPointRegisterCharge), { sortedRows: sortedRows });
    });
}
exports.useConsumptionRows = useConsumptionRows;
// formats meter readings into Reading for display
// modified from ../charges-in-detail/fuel/FuelSection
function meterReadings(rates) {
    return rates
        .map(function (_a, index) {
        var openingRead = _a.openingRead, startDate = _a.startDate, openingReadType = _a.openingReadType, closingRead = _a.closingRead, endDate = _a.endDate, closingReadType = _a.closingReadType, intermediateReads = _a.intermediateReads;
        var openingReading = index === 0 || openingReadType === 'MexReadingInitial'
            ? [
                {
                    description: "".concat((0, date_fns_1.format)(startDate, 'd MMM')),
                    reading: openingRead,
                    readTypeContext: readingContext(openingReadType),
                },
            ]
            : [];
        var middleReadings = intermediateReads.map(function (_a) {
            var read = _a.read, readType = _a.readType, date = _a.date;
            return ({
                description: (0, exports.modifyAndFormatDate)(date, readType),
                reading: read,
                readTypeContext: readingContext(readType),
            });
        });
        var closingReading = {
            description: "".concat((0, exports.modifyAndFormatDate)(endDate, closingReadType)),
            reading: closingRead,
            readTypeContext: readingContext(closingReadType),
        };
        return openingReading.concat(middleReadings).concat([closingReading]);
    })
        .reduce(function (a, b) { return a.concat(b); }, []);
}
exports.meterReadings = meterReadings;
function readingContext(readType) {
    return (0, utils_1.isEstimatedReadingType)(readType) ? 'Estimated' : 'Actual';
}
exports.readingContext = readingContext;
var modifyAndFormatDate = function (date, readType) {
    return readType === 'ManualReading'
        ? (0, date_fns_1.format)((0, date_1.tomorrow)(date), 'd MMM')
        : (0, date_fns_1.format)(date, 'd MMM');
};
exports.modifyAndFormatDate = modifyAndFormatDate;
